import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/results")({
  component: lazyRouteComponent(
    () => import("@/features/results/components/results-page"),
    "ResultsPage",
  ),
});
